import { motion } from "framer-motion";

// Shared editorial two-column spotlight used for "coming in the full app" flagships.
export default function SpotlightSection({
  id,
  testId,
  label,
  labelColor = "#FFB7C6",
  lead,
  accent,
  tail = ".",
  body,
  tags = [],
  reverse = false,
  accentGradient,
  visual,
}) {
  const textOrder = reverse ? "order-2 md:order-2" : "order-2 md:order-1";
  const visualOrder = reverse ? "order-1 md:order-1" : "order-1 md:order-2";

  return (
    <section
      id={id}
      data-testid={testId}
      className="relative border-t border-[#F4F1EC]/10 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 opacity-70" style={{ background: accentGradient }} />
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-12 md:gap-10 items-center">
          <div className={`col-span-12 md:col-span-6 ${textOrder}`}>
            <div className="text-[11px] uppercase tracking-[0.32em] font-body" style={{ color: labelColor }}>
              {label}
            </div>
            <h2 className="mt-4 font-display tracking-tight leading-[1.02] text-[clamp(2.2rem,5vw,3.8rem)] font-medium text-[#F4F1EC]">
              {lead} <span className="italic font-light text-aurora">{accent}</span>
              {tail}
            </h2>
            <p className="mt-6 font-body text-[#F4F1EC]/75 text-lg leading-[1.75] max-w-xl">{body}</p>
            {tags.length > 0 && (
              <div className="mt-8 flex flex-wrap gap-2">
                {tags.map((t) => (
                  <span
                    key={t}
                    className="font-body text-[11px] uppercase tracking-[0.18em] text-[#F4F1EC]/70 border border-[#F4F1EC]/15 px-3 py-1.5"
                  >
                    {t}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className={`col-span-12 md:col-span-6 ${visualOrder}`}>{visual}</div>
        </div>
      </div>
    </section>
  );
}

export function VisualFrame({ children, badge = "Coming in the full app", gradient }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className="relative aspect-[4/3] border border-[#F4F1EC]/15 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0" style={{ background: gradient }} />
      <div aria-hidden className="absolute inset-0 wynn-grain opacity-40" />
      <div className="relative h-full w-full flex flex-col items-center justify-center">{children}</div>
      {badge && (
        <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.24em] text-[#F4F1EC]/80 font-body bg-[#070608]/50 px-2.5 py-1 border border-[#F4F1EC]/20">
          {badge}
        </div>
      )}
    </motion.div>
  );
}
